import { ValueObject } from '@nx-smartmonkey/shared/domain';

interface ProjectViewVehicleProps {
  external_id: boolean;
  comments: boolean;
  plate: boolean;
  phone: boolean;
  email: boolean;
  price_per_minute: boolean;
  price_per_distance: boolean;
}

export class ProjectViewVehicle extends ValueObject<ProjectViewVehicleProps> {
  get external_id(): boolean {
    return this.props.external_id;
  }
  set external_id(externalId: boolean) {
    this.props.external_id = externalId;
  }
  get comments(): boolean {
    return this.props.comments;
  }
  set comments(comments: boolean) {
    this.props.comments = comments;
  }
  get plate(): boolean {
    return this.props.plate;
  }
  set plate(plate: boolean) {
    this.props.plate = plate;
  }
  get phone(): boolean {
    return this.props.phone;
  }
  set phone(phone: boolean) {
    this.props.phone = phone;
  }
  get email(): boolean {
    return this.props.email;
  }
  set email(email: boolean) {
    this.props.email = email;
  }
  get price_per_minute(): boolean {
    return this.props.price_per_minute;
  }
  set price_per_minute(pricePerMinute: boolean) {
    this.props.price_per_minute = pricePerMinute;
  }
  get price_per_distance(): boolean {
    return this.props.price_per_distance;
  }
  set price_per_distance(pricePerDistance: boolean) {
    this.props.price_per_distance = pricePerDistance;
  }
  private constructor(props: ProjectViewVehicleProps) {
    super(props);
  }
  static create(props: ProjectViewVehicleProps): ProjectViewVehicle {
    return new ProjectViewVehicle(props);
  }
}
